exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-not-found {\r\n    background-repeat: no-repeat;\r\n    background-size: 150px;\r\n    background-position: center center;\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 0;\r\n}", ""]);

// exports
